import {
  SELECTED_REPOSITORY,
  SELECTED_REPOSITORY_VERSION,
  IS_SELECTED_REPOSITORY,
  IS_ADD_ARTICLE,
  IS_MAXIMIZE_ADD_ARTICLE
} from '../../common/actionTypes';

const INITIAL_STATE = {
  selectedRepository: {},
  selectedRepositoryVersion: {},
  isSelectedRepository: false,
  isAddArticle: false,
  isMaximizeAddArticle: false,
};

const KBUtilityReducer = (state = INITIAL_STATE, action) => {
  if (action.type === undefined) {
    return state;
  }
  switch (action.type) {
    case SELECTED_REPOSITORY: {
      return { ...state, selectedRepository: action.payload };
    }
    case IS_SELECTED_REPOSITORY: {
      return { ...state, isSelectedRepository: action.payload };
    }
    case SELECTED_REPOSITORY_VERSION: {
      return { ...state, selectedRepositoryVersion: action.payload };
    }
    case IS_ADD_ARTICLE: {
      return { ...state, isAddArticle: action.payload };
    }
    case IS_MAXIMIZE_ADD_ARTICLE: {
      return { ...state, isMaximizeAddArticle: action.payload };
    }

    default:
      return state;
  }
};

export default KBUtilityReducer;
